/* @flow */

import * as React from 'react';

import StaticItem from 'app/components/styled/StaticItem';
import Rows from 'app/components/layout/Rows';

type Props = {
  items: Array<*>,
  render: (item: Object) => any
};

function LabelsList({ items, render }: Props) {
  return (
    <Rows desktop={4} mobile={1}>
      {items.map((item, i) => (
        <StaticItem key={item.id} underline={i < items.length - 1}>
          {render(item)}
        </StaticItem>
      ))}
    </Rows>
  );
}

export default LabelsList;
